import "../../styles/website/Home.css";
import "../../styles/website/AboutUs.css";
import Layout from "../website/component/Layout";

import flowerTop from "../../assets/website/flower-header.svg";
// مسیر این ۶ عکس رو با عکس‌های واقعی گالری خودت جایگزین کن
import gallery1 from "../../assets/website/aboutus/1.jpg";
import gallery2 from "../../assets/website/aboutus/4.jpg";
import gallery3 from "../../assets/website/aboutus/3.jpg";
import gallery4 from "../../assets/website/aboutus/6.jpg";
import gallery5 from "../../assets/website/aboutus/8.jpg";

/* =========================================================
   آیکون‌های خطی (SVG) — هماهنگ با تم پروژه
   ========================================================= */

function IconCode() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 6 3 12 9 18" />
      <polyline points="15 6 21 12 15 18" />
    </svg>
  );
}

function IconShield() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

function IconBolt() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="13 2 4 14 11 14 10 22 20 9 13 9 13 2" />
    </svg>
  );
}

function IconShirt() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 4L4 7l2 3 2-1.5V20h8V8.5L18 10l2-3-4-3-2 2h-4L8 4z" />
    </svg>
  );
}

function IconDevice() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="6" y="3" width="12" height="18" rx="2" />
      <line x1="10" y1="18" x2="14" y2="18" />
    </svg>
  );
}

/* =========================================================
   داده‌ها
   ========================================================= */

const STATS = [
  { num: "۵٬۰۰۰+", label: "فروشگاه فعال" },
  { num: "۹۸٪", label: "رضایت کاربران" },
];

const VALUE_FEATURES = [
  {
    Icon: IconCode,
    title: "کد تمیز",
    text: "معماری خوانا، مقیاس‌پذیر و قابل نگهداری",
  },
  {
    Icon: IconShield,
    title: "امنیت بالا",
    text: "زیرساخت امن برای حفاظت از داده‌های شما",
  },
  {
    Icon: IconBolt,
    title: "سرعت عالی",
    text: "بارگذاری فوق‌سریع در هر شرایطی",
  },
];

const PREVIEW_SHOPS = [
  { Icon: IconShirt, name: "فروشگاه پوشاک" },
  { Icon: IconDevice, name: "فروشگاه دیجیتال" },
];

const WHY_US = [
  {
    title: "ثبت‌نام ۳ دقیقه‌ای",
    text: "با شماره موبایل وارد شو و فروشگاهت رو بساز.",
  },
  { title: "بدون قطعی", text: "فروشگاهت روی اینترنت داخلی هم کاملاً فعاله." },
  { title: "واکنش‌گرا", text: "روی موبایل، تبلت و دسکتاپ عالی دیده می‌شه." },
  { title: "امن و پایدار", text: "زیرساخت قوی؛ داده‌هات همیشه در امانه." },
  { title: "۱۰٪ هدیه معرفی", text: "برای هر فروشگاهی که برای دیگران بسازی." },
  {
    title: "فروش سراسری",
    text: "بدون محدودیت جغرافیایی، از هر جای ایران سفارش بگیر.",
  },
];

const TEAM = [
  {
    letter: "م",
    name: "محمد پارسا نجفی",
    role: "کارشناس it و توسعه دهنده",
    years: "5 سال تجربه",
  },
  {
    letter: "ز",
    name: "زهرا سلطانی",
    role: "توسعه‌دهنده ارشد بک‌اند",
    years: "8 سال تجربه",
  },
  {
    letter: "ر",
    name: "رضوان خیرکار",
    role: "توسعه‌دهنده فرانت‌اند",
    years: "6 سال تجربه",
  },
  {
    letter: "آ",
    name: "آیناز بهداد معین",
    role: "دیجیتال مارکتر",
    years: "2 سال تجربه",
  },
  {
    letter: "س",
    name: "سارا پاینده",
    role: "کارشناس فروش ",
    years: "4 سال تجربه",
  },
  {
    letter: "ن",
    name: "نازنین دائمی",
    role: "کارشناس فروش",
    years: "2 سال تجربه",
  },

];

const GALLERY = [
  { src: gallery1, size: "gallery-lg" },
  { src: gallery2, size: "gallery-sm" },
  { src: gallery3, size: "gallery-sm" },
  { src: gallery4, size: "gallery-wide" },
  { src: gallery5, size: "gallery-sm" },
];

const COMPANY_BADGES = [
  "عضو پارک علم و فناوری یزد",
  "سرمایه‌گذاری چندین‌ساله در R&D",
  "تیم ۱۰نفره متخصص",
  "پشتیبانی ۲۴/۷",
];

/* =========================================================
   محافظت از تصاویر (جلوگیری از باز کردن/دانلود/کپی)
   ========================================================= */

// جلوی منوی راست‌کلیک، درگ کردن و انتخاب تصویر رو می‌گیره.
// نکته: این روش‌ها سمت کلاینت هستن و ۱۰۰٪ ضدنفوذ نیستن (کاربر حرفه‌ای
// همیشه می‌تونه از طریق devtools/network به فایل دسترسی پیدا کنه)،
// ولی جلوی دانلود/ذخیره‌ی معمولی از طریق کلیک راست یا درگ رو می‌گیرن.
function preventImageActions(e) {
  e.preventDefault();
  return false;
}

const protectedImgStyle = {
  userSelect: "none",
  WebkitUserSelect: "none",
  WebkitTouchCallout: "none", // جلوگیری از منوی «ذخیره تصویر» در سافاری موبایل
  pointerEvents: "auto",
};

/* =========================================================
   ساب‌کامپوننت‌ها
   ========================================================= */

function WhyTile({ title, text, index }) {
  return (
    <div className="tile-dark why-tile" style={{ "--d": `${index * 0.08}s` }}>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

function TeamCard({ letter, name, role, years, index }) {
  return (
    <div className="tile team-card" style={{ "--d": `${index * 0.07}s` }}>
      <div className="team-avatar">{letter}</div>
      <h4>{name}</h4>
      <p>{role}</p>
      <span className="team-years">{years}</span>
    </div>
  );
}

function FeatureItem({ Icon, title, text, index }) {
  return (
    <div className="feature-item" style={{ "--d": `${index * 0.12}s` }}>
      <span className="feature-icon">
        <Icon />
      </span>
      <div className="feature-body">
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </div>
  );
}

function GalleryItem({ src, title, size, index }) {
  return (
    <div
      className={`gallery-item ${size || ""}`}
      style={{ "--d": `${index * 0.07}s` }}
      onContextMenu={preventImageActions}
    >
      <img
        src={src}
        alt={title}
        loading="lazy"
        draggable={false}
        onContextMenu={preventImageActions}
        onDragStart={preventImageActions}
        style={protectedImgStyle}
      />
      {/* لایه‌ی شیشه‌ای شفاف روی عکس؛ جلوی لانگ‌پرس/درگ در مرورگرهای موبایل رو می‌گیره */}
      <span className="gallery-item-shield" aria-hidden="true" />
      <div className="gallery-item-overlay">
        <span>{title}</span>
      </div>
    </div>
  );
}

/* =========================================================
   کامپوننت اصلی
   ========================================================= */

export default function AboutUs() {
  return (
    <Layout>
      <img className="image-flower-top" src={flowerTop} alt="" />

      {/* ---------- Hero ---------- */}
      <section className="about-hero">
        <div className="wrap about-hero-grid">
          <div className="about-hero-text">
            <h1>ما آینده فروش آنلاین ایران رو می‌سازیم</h1>
            <p className="about-hero-sub">
              گروه مهندسی باورسازان هوشمند، سال‌هاست با یک هدف کار می‌کنه:
              دسترسی هر کسب‌وکاری به فروشگاه اینترنتی اختصاصی خودش.
            </p>

            <div className="hero-stats-row">
              {STATS.map((s, i) => (
                <div className="hero-stat" key={s.label}>
                  {i > 0 && (
                    <span className="hero-stat-sep" aria-hidden="true" />
                  )}
                  <b>{s.num}</b>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="about-hero-visual">
            <div className="shop-stack">
              {PREVIEW_SHOPS.map((s, i) => (
                <div className={`shop-peek shop-peek-${i + 1}`} key={s.name}>
                  <span className="shop-peek-icon">
                    <s.Icon />
                  </span>
                  <span className="shop-peek-name">{s.name}</span>
                </div>
              ))}

              <div className="tile-dark shop-live">
                <div className="shop-live-bar">
                  <span className="shop-live-dot" />
                  <span className="shop-live-dot" />
                  <span className="shop-live-dot" />
                  <span className="shop-live-url">yourshop.dokana.ir</span>
                </div>

                <div className="shop-live-header">
                  <span className="shop-live-logo">🛍</span>
                  <span className="shop-live-name">فروشگاه شما</span>
                </div>

                <div className="shop-live-products">
                  <span className="shop-live-product" />
                  <span className="shop-live-product" />
                  <span className="shop-live-product" />
                </div>

                <div className="shop-live-cta">افزودن به سبد خرید</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- Story ---------- */}
      <section className="story" id="story">
        <div className="wrap story-grid">
          <div className="story-text">
            <h2>از یک ایده تا هزاران فروشگاه</h2>
            <p style={{ marginTop: 16 }}>
              چند سال پیش یک سؤال ساده همه‌چیز رو شروع کرد: چرا یک کسب‌وکار کوچک
              باید محصولاتش رو تو سایت‌های واسطه بذاره و کارمزد بده؟ تیم
              ۱۰نفره‌ی ما از بهترین مهندسان نرم‌افزار، سال‌ها روی این سؤال کار
              کرد تا یک پلتفرم حرفه‌ای بسازه؛ نه یک راه‌حل موقت.
            </p>
            <p>
              امروز، زیر نظر پارک علم و فناوری یزد و با حمایت گروه مهندسی
              باورسازان هوشمند، این پلتفرم آماده‌ست فروش آنلاین رو برای همه ممکن
              کنه.
            </p>
          </div>

          <div className="story-features">
            {VALUE_FEATURES.map((f, i) => (
              <FeatureItem key={f.title} {...f} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Why us ---------- */}
      <section className="why-now">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>چرا ما؟</h2>
              <p>همه چیزی که برای فروش آنلاین نیاز داری.</p>
            </div>
          </div>
          <div
            className="why-grid"
            // style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
          >
            {WHY_US.map((tile, i) => (
              <WhyTile key={tile.title} {...tile} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Final CTA (glass) ---------- */}
      <section className="about-cta">
        <div className="wrap about-cta-wrap">
          <div className="cta-glow cta-glow-1" aria-hidden="true" />
          <div className="cta-glow cta-glow-2" aria-hidden="true" />
          <div className="glass-cta">
            <h2>آماده‌ای فروشگاهت رو بسازی؟</h2>
            <p>
              همین الان ثبت‌نام کن. ۳ دقیقه وقت می‌بره. هیچ کارت بانکی لازم
              نیست.
            </p>
            <div className="about-cta-actions">
              <a href="/panel/login" className="btn btn-primary btn-lg">
                شروع رایگان
              </a>
              <a href="/pricing" className="btn btn-ghost btn-lg">
                مشاهده تعرفه‌ها
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- Team ---------- */}
      <section className="team" id="team">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>پشت صحنه</h2>
              <p>
                ۱۰ متخصص با سال‌ها تجربه، زیر نظر گروه مهندسی باورسازان هوشمند.
              </p>
            </div>
          </div>
          <div className="team-grid">
            {TEAM.map((member, i) => (
              <TeamCard key={member.name} {...member} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Gallery ---------- */}
      <section className="gallery" id="gallery">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>گالری</h2>
              <p>نگاهی به فروشگاه‌ها و لحظات تیم دُکانا.</p>
            </div>
          </div>
          <div className="gallery-grid">
            {GALLERY.map((img, i) => (
              <GalleryItem key={img.title} {...img} index={i} />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
